import { sharedStockRow } from '@/utils/stockQuoteFeed'
import { quoteNumber } from '@/utils/quoteDisplay'

// Display-only valuation: same cost basis as vexe Contract.positionList, no order mutation.
export function hongKongPositions(rows, market = 'hk') {
  return (rows || []).map(row => {
    const quote = sharedStockRow({ full_code: row.full_code || row.symbol, price: row.market_last_price }, market)
    const price = quoteNumber(quote.price), quantity = quoteNumber(row.total_num)
    if (!(price > 0) || quantity == null) return row
    const cost = Number(row.trade_type) === 1 ? quoteNumber(row.buy_avg_cost_price)
      : Number(row.trade_type) === 2 && quoteNumber(row.buy_avg_price) != null && quoteNumber(row.buy_avg_fee_price) != null ? Number(row.buy_avg_price) - Number(row.buy_avg_fee_price) : null
    const updated = { ...row, market_last_price: quote.price, market_value: Number((price * quantity).toFixed(2)) }
    if (cost == null) return { ...updated, float_pl: null, float_pl_ratio: null }
    const profit = Number(((price - cost) * quantity * (Number(row.trade_type) === 2 ? -1 : 1)).toFixed(2))
    return { ...updated, real_cost_price: Number(cost.toFixed(4)), float_pl: profit, float_pl_ratio: cost * quantity > 0 ? Number((profit / (cost * quantity) * 100).toFixed(2)) : null }
  })
}
